<!-- PASS -->
<template>
	<div>
		<!-- // * CONTENT TITLE -->
		<v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
			<app-text category="content-title">
				<div class="d-flex align-center">
					<v-icon v-if="form.passStatus === 'APPROVED'" class="display-1 success--text icons8-checkmark-yes"></v-icon>
					<v-icon v-if="form.passStatus === 'REJECTED'" class="display-1 warning--text icons8-high-importance"></v-icon>
					<v-icon v-if="form.passStatus === 'PENDING'" class="display-1 grey--text icons8-circle"></v-icon>
					<v-icon v-if="form.passStatus === 'SUSPENDED'" class="display-1 grey--text text--lighten-1 icons8-private"></v-icon>

					<span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
					<span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + "Name"] }} </span>
				</div>
			</app-text>
			<v-spacer></v-spacer>
			<div v-if="['SM', 'SA', 'DA'].includes(GET_currentUser.userLevel)" class="d-flex align-center">
				<appbutton :label="$t(`buttons.approve`)" v-if="form.passStatus === 'PENDING' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-checkmark-yes" type="success" class="mr-0" @click.native="updateItemStatus('APPROVED')" showlabel="xlOnly" />
				<appbutton :label="$t(`buttons.reject`)" v-if="form.passStatus === 'PENDING' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-high-importance" type="warning" class="mr-0" @click.native="updateItemStatus('REJECTED')" showlabel="xlOnly" />
				<appbutton :label="$t(`buttons.suspend`)" v-if="form.passStatus === 'APPROVED' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-private" type="error" class="mr-0" @click.native="updateItemStatus('SUSPENDED')" showlabel="xlOnly" />
				<appbutton :label="$t(`buttons.restore`)" v-if="form.passStatus === 'SUSPENDED' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-private" type="success" class="mr-0" @click.native="updateItemStatus('APPROVED')" showlabel="xlOnly" />
			</div>
		</v-row>
		<v-divider class="grey lighten-1"></v-divider>
		<!-- // * CONTENT -->
		<v-container fluid class="pa-0">
			<v-row no-gutters class="">
				<v-col cols="12" xs="6" lg="12" class="">
					<v-row class="ma-0" no-gutters>
						<!-- // * TABS MENU -->
						<v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
							<v-tabs-slider color="red" background-color="black"></v-tabs-slider>
							<v-tab href="#overview" class="white"
								><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab
							>
						</v-tabs>
						<!-- // * TABS ITEMS -->
						<v-tabs-items v-model="tabs" class="appbackground">
							<v-tab-item value="overview" class="pa-0">
								<v-row class="mt-2 mx-1 mr-2" no-gutters>
									<v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
										<v-row class="mt-4" no-gutters>
											<!-- // * DESCRIPTION -->
											<v-col class="pl-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-row class="pa-0 ma-0">
                                                    <div>
												        <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
												        <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>
                                                    </div>
                                                    <v-spacer />
												    <appbutton :label="$t(`buttons.print`)" icon="icons8-print" type="secondary" class="mr-1" @click.native="openPass(form.id)" :na="formMode !== 'View'" :class="{ disabled: formMode !== 'View' }" showlabel="xlOnly" />
                                                </v-row>
                                                <v-divider class="my-4 mr-2" />
											</v-col>
											<!-- // * ACTION BAR -->
											<v-col class="pa-0 d-flex px-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
												<appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple" class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ disabled: formMode !== 'View' }" showlabel="xlOnly" />
												<appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary" class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ disabled: formMode !== 'View' }" showlabel="xlOnly" />

                                                
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New' && form.passStatus === 'PENDING'" icon="icons8-edit-property" type="secondary" class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ disabled: formMode !== 'View' }" showlabel="xlOnly" />
											    <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New' && ['SM','SA','DA'].includes(GET_currentUser.userLevel)" icon="icons8-edit-property" type="secondary" class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ disabled: formMode !== 'View' }" showlabel="xlOnly" />
                                                
                                                <v-spacer />
												<appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2" class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
												<appbutton :label="$t(`buttons.request`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-email-send" type="info" class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />
											</v-col>
										</v-row>
										<!-- // * FORM v-on:submit.prevent="validateForm()" v-model="formValid" -->
										<v-form ref="form">
											<v-row class="mt-2" no-gutters>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                    <v-text-field autocomplete="donotautocomplete" color="black" :label="$t(`fields.reason`)" v-model="form.passName" filled hide-details="auto" :rules="rules.passName" required :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }"></v-text-field>
                                                </v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6">
													<v-autocomplete :menu-props="{ top: false, offsetY: true }" :attach="true" color="black" return-object :label="$t(`fields.site`)" v-model="form.site" :items="sites" item-text="siteName" filled hide-details="auto" :rules="rules.site" required :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:item="data">{{ data.item.siteName }}</template>
														<template v-slot:selection="data">{{ data.item.siteName }}</template>
													</v-autocomplete>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
													<v-text-field color="black" clearable @click="MIX_datePicker(true, 'startDate')" append-icon="mdi-calendar" :label="$t('fields.startDate')" v-model="formattedStartDate" filled hide-details="auto" :rules="rules.startDate" :background-color="formBackground" dense :readonly="true" :class="{ disabled: formReadOnly }"></v-text-field>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
													<v-text-field color="black" clearable @click="MIX_datePicker(true, 'endDate')" append-icon="mdi-calendar" :label="$t('fields.endDate')" v-model="formattedEndDate" filled hide-details="auto" :rules="rules.endDate" :background-color="formBackground" dense :readonly="true" :class="{ disabled: formReadOnly }"></v-text-field>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
													<v-text-field color="black" :label="$t('fields.noOfDays')" v-model="noOfDays" filled hide-details="auto" :rules="rules.noOfDays"  :background-color="formBackground" dense :readonly="true" :class="{ disabled: true }"></v-text-field>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12">
													<v-autocomplete :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  autocomplete="donotautocomplete" :label="$t(`fields.sponsor`)" v-model="form.passHost" :items="usersHosts" item-text="userName" return-object filled hide-details="auto" :rules="rules.passHost" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:item="data">
															{{ data.item.userName }}
															<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
														</template>
														<template v-slot:selection="data">
															{{ data.item.userName }}
															<span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.userJobTitle }}</span>
														</template>
													</v-autocomplete>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
													<v-textarea color="black"  :label="$t(`fields.description`)" v-model="form.passDescription" filled hide-details="auto" :background-color="formBackground" auto-grow rows="5" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:item="data">{{ data.item.text }}</template>
														<template v-slot:selection="data">{{ data.item.text }}</template>
													</v-textarea>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
													<v-autocomplete :menu-props="{ top: true, offsetY: true }" :attach="true" color="black"  autocomplete="donotautocomplete" @change="getUsersFromOrganisation()" :label="$t(`fields.organisation`)" v-model="form.organisation" :items="organisations" item-text="organisationName" return-object filled hide-details="auto" :rules="rules.organisation" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:item="data">{{ data.item.organisationName }}</template>
														<template v-slot:selection="data">{{ data.item.organisationName }}</template>
													</v-autocomplete>
												</v-col>
												<v-col class="my-2 px-2" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
													<v-select :menu-props="{ top: true, offsetY: true }" :attach="true" v-if="['SA','DA'].includes(GET_currentUser.userLevel)" color="black"  :label="$t(`fields.status`)" v-model="form.passStatus" :items="passStatus" item-name="text" filled hide-details="auto" :rules="rules.status" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:item="data">{{ data.item.text }}</template>
														<template v-slot:selection="data">{{ data.item.text }}</template>
													</v-select>
                                                    <v-text-field v-else color="black" :label="$t('fields.status')" v-model="form.passStatus" filled hide-details="auto" :rules="rules.status"  :background-color="formBackground" dense :readonly="true" :class="{ disabled: true }"></v-text-field>
												</v-col>
												<v-col class="my-2 px-2" cols="12">
                                                    <!-- <pre>{{ computedUsersfromOrganisations }}</pre> -->
													<v-autocomplete :menu-props="{ top: true, offsetY: true }" :attach="true" color="black"  chips multiple no-data-text="Please Select Organisation First" :label="$t(`fields.personsRequired`)" v-model="form.users" :items="computedUsersfromOrganisations" item-text="userName" item-value="userId" filled hide-details="auto" :rules="rules.users" required :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
														<template v-slot:selection="{ item, index }">
															<span v-if="index === 0">{{ item.userName }}</span>
															<span v-if="index === 1" class="grey--text caption ml-2"> and {{ form.users - 1 }} other </span>
														</template>
													</v-autocomplete>
												</v-col>
												<v-col class="my-4 px-2 d-flex flex-column" cols="12" xs="12" sm="6" md="6" lg="6">
                                                    <!-- <pre>{{ this.form.users }}</pre> -->
													<div class="font-weight-bold">Persons Listed on Visitor Pass</div>
													<div v-if="JSON.stringify(form.users) !== '[]'">
														<div class="" v-for="user in form.users" :key="user">
															<v-icon @click="MIX_popupUser(user)" class="info--text">icons8-identification-documents</v-icon>
														    {{ getUserDetails(user, 'userName') }} <span class="caption grey--text text-darken-2">{{ getUserDetails(user, 'userJobTitle') }}</span>
														</div>
													</div>
												</v-col>
                                                <!-- <v-col>
                                                    <h1>{{ usersFromOrganisation}}</h1>
                                                    <pre>{{ usersFromOrganisation }}</pre>
                                                </v-col> -->
											</v-row>
										</v-form>
									</v-col>
								</v-row>
							</v-tab-item>
						</v-tabs-items>
					</v-row>
					<!-- <pre align="left">
                        {{ form }}
                    </pre> -->
				</v-col>
			</v-row>
                
		</v-container>

	</div>
</template>

<script>
	import { mapGetters, mapState, mapActions } from "vuex"; // Map the Getters from the Vuex Store
	export default {
		// * DATA
		data: () => ({
			// * PAGE DETAILS
			collection: "passes",
			collectionTitle: "Visitor Passes",
			collectionItem: "pass",
			collectionItemTitle: "Visitor Pass",
			langPath: "passes.pass",
			tabs: "overview",
			// * FORM RELATED
			form: {
				// all users manual entry
				// id: "",
				passName: "", // name of pass
				passDescription: "", // description of pass
				startDate: "",
				endDate: "",
				passStatus: "PENDING", // status of the pass, should be set PENDING by default
				passHost: "",
				site: null,
				// 	siteName: "",
				// 	siteType: "",
				// 	sitePostcode: "",
				// },
				organisation: null,
                users: [],
				// TODO NEED TO ADD PERSON TO WHOME PASS WILL BE SENT TO
				// automatic based on logged in user
				createdUserId: "", // user id of person who created the pass
				createdDateTime: "", // timestamp when the pass was created
				modifiedUserId: "", // user id of the person who last modified the record
				modifiedDateTime: "", // timestamp when the pass was last modified
			},
			formMode: "New", // Show Form in New Mode / Blank
			formReadOnly: false, // Make Form Editable
			formValid: false,
			formBackground: "grey lighten-3",
			passTypes: [], // Populated by Lookup Values
			passStatus: [], // Populated by Lookup Values
			userTypes: [], // Populated by Lookup Values
			siteTypes: [], // Populated by Lookup Values
			sites: [], // Populated by GET_sites
			usersHosts: [],
			organisations: [],
			usersFromOrganisation: [],
			// * PASS RELATED
			formattedStartDate: "", // holds the formated version of the Project Start Date
			formattedEndDate: "", // holds the formated version of the Project Start Date
			usersSelected: [], // used for counting usersSelected
            noOfDays: 0,
            rules: {}

            
		}),
		// * COMPUTED
		computed: {
			...mapGetters({
				GET_openItem: "GET_openPass", // Get Open pass Data
				GET_lookupValues: "GET_lookupValues", // Get Lookup Values
				GET_organisations: "GET_organisations", // Get Organisations
				GET_sites: "GET_sites", // Get Sites,
				GET_projects: "GET_projects", // Get Projects,
				GET_usersHosts: "GET_usersHosts", // Get User Hosts
				GET_confirmBoxResult: "confirmBox_store/GET_confirmBoxResult", // Get Confirm Box Result
				GET_datePickerResult: "datePicker_store/GET_datePickerResult", // Get Date Picker Result
				GET_help: "GET_help",
			}),
			// ...mapState({
			// 	uploadedFile: (state) => state.upload_file_store.file,
			// }),
			// uploadButtonName() {
			// 	console.log("form: " + this.form.fileData.fileName + "\nfile: " + this.uploadedFile);
			// 	if (this.form.fileData.fileName == null && this.uploadedfile == null) {
			// 		return "ADD PDF";
			// 	} else {
			// 		return "REPLACE PDF";
			// 	}
			// },
			// Disable Users that are not approved within user selection dropdowns
			computedUsersfromOrganisations() {
				return this.usersFromOrganisation.map((item) => {
					return {
						userId: item.userId,
						userName: `${item.userName} (${item.userStatus})`,
						userStatus: item.userStatus,
						userType: item.userType,
						userRole: item.userRole,
						organisationName: item.organisationName,
						organisationId: item.organisationId,
						disabled: item.userStatus !== "APPROVED", //true //this.disabledItems.includes(item)
					};
				});
			},
			computedUsersListed() {
				return this.form.users.length;
			},

		},
		// * WATCH
		watch: {
			// GET CONFIRMATION RESULT
			GET_confirmBoxResult: {
				handler: async function() {
					var t = this;
					// console.log('t.GET_confirmBoxResult.data = ' + JSON.stringify(t.GET_confirmBoxResult.data, null, 2))
					switch(t.GET_confirmBoxResult.data.action) {
						case 'passes/delete':
							if (t.GET_confirmBoxResult.data.result === "YES") {
								var deleteResult = await t.MIX_deleteDocument(t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
							if (deleteResult.code === 1) {
								t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null);
								t.closeRightPanel();
							} else {
								t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error);
							}
						}
							break;
						case 'passes/save':
							if (t.GET_confirmBoxResult.data.result === "YES") {
								t.saveItem();
							} else {
								t.MIX_alert(-1, `Error Saving`, null, null);
							}							
							break;
					}
				},
				deep: true,
			},
			GET_datePickerResult: {
				// Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
				handler() {
					switch (this.GET_datePickerResult.field) {
						case "startDate":
							this.form.startDate = this.GET_datePickerResult.value; // Update the Form Start Date
							this.formattedStartDate = this.MIX_formatDateTime(this.form.startDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
							break;
						case "endDate":
							this.form.endDate = this.GET_datePickerResult.value; // Update the Form Start Date
                            this.form.endDate = this.$moment(this.form.endDate, 'x').endOf('day').format('x');
							this.formattedEndDate = this.MIX_formatDateTime(this.form.endDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
							break;
						default:
							//do nothing
							break;
					}

				},
				deep: true,
			},
			form: {
			    handler() {
                    if ((this.form.startDate === '') || (this.form.endDate === '')) {
                        this.noOfDays = 0;
                    // } else if (this.form.startDate === this.form.endDate ) {
                    //     this.noOfDays = 1;
                    } else {
                        this.noOfDays = this.$moment(this.form.endDate, "x").diff(this.$moment(this.form.startDate, "x"), 'days') + 1;
                    }
			    }, deep: true
			},
            formattedStartDate() {
                if (this.formattedStartDate === null) {
                    this.form.startDate = '';
                }
            },
            formattedEndDate() {
                if (this.formattedEndDate === null) {
                    this.form.endDate = '';
                }
            },
			// watch for changes to the file in the store
			uploadedFile: {
				handler: function() {
					this.uploadedFile;
				},
				deep: true,
			},
		},
		// * METHODS
		methods: {
			...mapActions({ ACT_openItem: "ACT_openPass" }),
			// UPDATE BREADCRUMBS
			updateBreadcrumbs() {
				var t = this;
				var breadcrumbs = [];
				breadcrumbs.push({ name: `${t.collectionTitle}`, path: `/${t.collection}` }); // Set the Main Path
				if (t.GET_openItem.process === "New") {
					breadcrumbs.push({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}` }); // Set a Secondary Path
				} else {
					breadcrumbs.push({ name: `${this.GET_openItem.data[t.collectionItem + "Name"]}`, path: `/${t.collection}/${this.GET_openItem.data.id}` }); // Set a Secondary Path
				}
				this.MIX_breadcrumbs(breadcrumbs);
			},
			// OPEN ITEM
			openItem: async function() {
				var t = this;
				var openItem = await t.GET_openItem; // Get Open Item Data
				switch (openItem.process) {
					case "New":
						t.formMode = "New"; // Show Form in New Mode
						t.formReadOnly = false; // Make Form Editable
						t.formBackground = "white"; // Change Background Colour of Form
						break;
					case "View":
						var item = await t.MIX_readDocumentById(t.collection, openItem.data.id);
						t.form = item.data; // Update the Form with the Open Item details
                        t.formMode = "View"; // Show Form in View Mode
						t.formReadOnly = true; // Make Form Read Only
						t.formBackground = "grey lighten-3"; // Change Background Colour of Form
                        t.formattedStartDate = t.MIX_formatDateTime(t.form.startDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
						t.formattedEndDate = t.MIX_formatDateTime(t.form.endDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project End Date
						break;
					case "Edit":
						var item = await t.MIX_readDocumentById(t.collection, openItem.data.id);
						t.form = item.data; // Update the Form with the Open Item details
						t.formMode = "Edit"; // Show Form in Edit Mode
						t.formReadOnly = false; // Make Form Editable
						t.formBackground = "white"; // Change Background Colour of Form
                        t.formattedStartDate = t.MIX_formatDateTime(t.form.startDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
						t.formattedEndDate = t.MIX_formatDateTime(t.form.endDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
                        break;
				}
				return;
			},
			// EDIT ITEM
			editItem() {
				var t = this;
				t.formMode = "Edit";
				t.formReadOnly = false;
				t.formBackground = "white";
			},
			// CANCEL ITEM
			cancelItem() {
				var t = this;
				t.formMode = "View";
				t.formReadOnly = true;
				t.formBackground = "grey lighten-3";
				t.removeUploadedDocument();
				t.refreshItemView();
                t.closeRightPanel();  
			},
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.MIX_closeView();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
			// SAVE ITEM
			saveItem: async function() {
				var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }                
                // console.log(JSON.stringify(t.form, null, 2))
				var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
				if (createDocumentResult.code === 1) {
					t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
					t.formMode = "View"; // Change Form Mode
					t.formReadOnly = true; // Set Form to Read Only
					t.formBackground = "grey lighten-3";
					t.refreshItemView();
					t.removeUploadedDocument();
				} else {
					t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
				}
			},
			// UPDATE ITEM STATUS
			updateItemStatus: async function(status) {
				var t = this;
				//console.log("updateResult");
				var updateResult = await t.MIX_updateDocumentFieldsById(t.collection, t.form.id, { [t.collectionItem + "Status"]: status });
				//console.log("updateResult.code = " + updateResult.code);
				if (updateResult.code === 1) {
					t.MIX_alert(1, "Status Updated", updateResult.data, null);
					t.refreshItemView();
				} else {
					t.MIX_alert(-1, "ERROR - Could not update Status", null, updateResult.error);
				}
			},
			// REFRESH ITEM VIEW
			refreshItemView: async function() {
				var t = this;
                if (t.form.id !== undefined) {
				    var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id);
				    var payload = {};
				    payload.process = "View";
				    payload.popup = false;
				    payload.data = itemResult.data;
				    t.ACT_openItem(payload);
				    t.openItem();
                }
			},
			// DELETE ITEM METHOD
			deleteItem: function(id) {
				var t = this;
				t.MIX_confirmBox({
					show: true,
					action: 'passes/delete',
                    collection: 'passes',
					id: id,
					title: `Delete ${t.collectionItemTitle}`,
					description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + "Name"]}</strong>?`,
					width: "400",
					height: "200",
					trueButtonText: "Yes",
					trueButtonValue: "YES",
					falseButtonText: "No",
					falseButtonValue: "NO",
				});
			},
			// UNDELETE ITEM METHOD
			undeleteItem: async function(id) {
				var t = this;
				var undeleteResult = await t.MIX_undeleteDocument(t.collection, id);
				if (undeleteResult.code === 1) {
					t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
				} else {
					t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
					// console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`);
				}
				t.refreshItemView();
			},
			// REMOVE UPLOADED DOCUMENT
			removeUploadedDocument() {
				this.$store.commit("upload_file_store/setFile", null);
			},
			//
			getUsersFromOrganisation: async function() {
				var t = this;
				//console.log("t.form = " + JSON.stringify(t.form, null, 2));
                    var usersResult = await t.MIX_usersFromOrganisation(t.form.organisation.organisationId);
				    if (usersResult.code === 1) {
				    	t.usersFromOrganisation = usersResult.data;
				    } else {
				    	// console.log("ERROR OCCURED - " + usersResult.message + "\n" + usersResult.error);
				    	// do nothing
				    }

            },
			getStaffContacts: async function() {
				var t = this;
				t.usersHosts = []
				
                t.$firebase.db.collection('users').where("userStaffContact", "==", true)
        			.where("userStatus", "==", "APPROVED")
                    .onSnapshot(function(querySnapshot) {
                        t.usersHosts = [];
                        querySnapshot.forEach(function(doc) {
                            var document = doc.data()
                            document.id = doc.id;
                            if (!document.hasOwnProperty('delete')) {
                                t.usersHosts.push(document);
                            } else if (t.showDeletedComments) {
                                 t.usersHosts.push(document);
                            } else {
                                // Do not Show Notice
                            }
                        });
					})

			},
			// getUserDetails: function(userId) {
			// 	// console.log("getUserDetails Updated " + userId);
			// 	var t = this;
			// 	var user = t.$find(t.usersFromOrganisation, { userId: userId });
			// 	// console.log("user = " + user);
			// 	return user;
			// },
            getUserDetails: function(userId, field) {
				var t = this;
				var user = t.$find(t.usersFromOrganisation, { userId: userId });
                if ((user !== undefined) && (user !== null) && (user !== '')) {
                    return user[field];
                } else {
                    return '';
                }
			},
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    passName: [
                        v => !!v || 'Reason is required',
                        v => (v && v.length < 255) || 'Name must be less than 255 characters',
                    ],
                    site: [v => !!v || 'Required'],
                    startDate: [v => !!v || "Day of First Visit Required"],
                    endDate: [v => !!v || "Day of Last Visit Required"],
                    noOfDays: [v => (v > 0 && v <= 7) || "Visitor Passes must be at least 1 Day and no more than 7 Days"],
                    passHost: [v => !!v || 'TFW Sponsor is required'],
                    organisation: [v => !!v || 'Organisation is required'],
                    users: [v => JSON.stringify(v) !== '[]' || 'You must specify who the pass is required for'],
                    status: [v => !!v || 'Status is required']
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {
                        //t.MIX_alert(1, "Passed validation.", null, null);
                        //it’s valid, do work
						t.MIX_confirmBox (
                    		{ 
                        		show: true,
                        		action: 'passes/save',
                                collection: 'passes',
                        		id: t.form.id,
                        		title: `Visitor Pass Declaration`, 
                        		description: `Please confirm that all Visitors listed on this pass are Medically fit to attend site and are not classed as vulnerable?`, 
                        		width: '300',
                        		height: '300',
                        		trueButtonText: 'Yes',
                        		trueButtonValue: 'YES',
                        		falseButtonText: 'No',
                        		falseButtonValue: 'NO',
      		              	}
			            )      
                        //this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
            openPass: async function(id) {
                var t = this;
                var item = {};
                var itemResult = await t.MIX_readDocumentById(t.collection, id)
                item.data = itemResult
                // console.log(JSON.stringify(item, null, 2))
                t.ACT_openItem(item);
                t.MIX_puDialog(true, 'printPass', '100vw', '100vh')
            }
		},
		async mounted() {
			var t = this;
			// * LOOKUP RELATED MOUNTED
			await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
			t.passStatus = await t.GET_lookupValues("PASSSTATUS");
			await t.MIX_usersHosts(); // Users who are STAFF and MANAGER / ADMIN
			t.usersHosts = t.GET_usersHosts;
			// * GET SITES
			t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY
			// * GET USERS
			// * GET ORGANISATIONS
			t.organisations = t.GET_organisations;

			// * ITEM RELATED MOUNTED
			var openItem = await t.GET_openItem; // Get Open Project Data
			t.formMode = openItem.process; // Show Form in View Mode
			if (openItem.process === "New") {
				t.formReadOnly = false; // Make Form Editable }
				t.formBackground = "white";
			} else {
				t.form = openItem.data; // Update the Form with the Open Project details
                t.formattedStartDate = t.MIX_formatDateTime(t.form.startDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
				t.formattedEndDate = t.MIX_formatDateTime(t.form.endDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
				t.formReadOnly = true;
				t.formBackground = "grey lighten-3";
				t.getUsersFromOrganisation();
			}
			if (openItem.popup === false) {
				t.updateBreadcrumbs();
			} // Update Breadcrumbs in Title
		},
	};
</script>

<style scoped>
	.disabled >>> .v-input__slot::before {
		border-style: none !important;
	}
    .v-dialog:not(.v-dialog--fullscreen) {
    height: 100vh;
}
.v-dialog {
    margin: 0px;
}
</style>
